import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
} from "react-router-dom";
import { I18nProvider } from "@/i18n/I18nProvider";
import ScrollToTop from "@/components/ScrollToTop";
import SiteLayout from "@/components/SiteLayout";
import Home from "@/pages/Home";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import Terms from "@/pages/Terms";
import ThankYou from "@/pages/ThankYou";
import NotFound from "@/pages/NotFound";
import "@/App.css";

const SUPPORTED = ["ec", "en"];

function LangGuard({ children }) {
  const { lang } = useParams();
  if (!SUPPORTED.includes(lang)) {
    return <Navigate to="/ec" replace />;
  }
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <I18nProvider>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Navigate to="/ec" replace />} />
          <Route path="/thank_you" element={<ThankYou />} />
          <Route
            path="/:lang"
            element={
              <LangGuard>
                <SiteLayout />
              </LangGuard>
            }
          >
            <Route index element={<Home />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="cookie-policy" element={<CookiePolicy />} />
            <Route path="terms" element={<Terms />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="*" element={<Navigate to="/ec" replace />} />
        </Routes>
      </I18nProvider>
    </BrowserRouter>
  );
}

export default App;
